import Amapiano from '../images/amapiano.jpg'
import AfroUk from '../images/afrouk.jpg'
import Disco from '../images/Disco.jpg'
import chilled from '../images/chilled.jpg'
import country from '../images/country.jpg'
import drill from '../images/drill.jpg'
import hiphop from '../images/hiphop.jpg'
import oldie from '../images/oldie.jpg'
import house from '../images/house.jpg'
import sunflower from '../images/sunflower.jpg'
import rhumba from '../images/rhumba.jpg'
import latino from '../images/latino.jpg'
import edm from '../images/edm.jpg'
import altrock from '../images/altrock.jpg'
import classicrock from '../images/classicrock.jpg'
import hadtobethere from '../images/hadtobethere.jpg'

const PlaylistData = [
    {
        
        imagesource: Amapiano,
        title: "Amapiano",
        text: 'Fresh from South africa, A new wave of african music shaping the continent.',
        spotify:'https://open.spotify.com/playlist/35BMEfYiE4jZztt4DdLdyb?si=66473f87236943d2',
    },

    {
        imagesource: AfroUk,
        title: "Afro-UK",
        text: 'African music with a blend of caribbean flow developed by Black british.',
        spotify:'https://open.spotify.com/playlist/3ZNM26aCZhzRNEX0VpZcMa?si=a1c523651e3e452f',
    },
    {
        imagesource: Disco,
        title: "OnlyDisco",
        text: '70s flow of undisputed rhythm and soulful music with funky properties.',
        spotify:'https://open.spotify.com/playlist/5wWKvP0iNN8r9mLWZUvvR3?si=d6df4857201949ac',
        
        
    },
    {
        imagesource: chilled,
        title: "Mellowmood",
        text: 'Enjoy a flow of easy-music, relax and feel the vibe from the greatest vocalists of all time.',
        spotify:'https://open.spotify.com/playlist/6ZmSxPgXnip2B6dHg3UC4n?si=9dec3731c0294f95',
        
    },
    {
        imagesource: country,
        title: "OnlyCountry",
        text: 'Howdy! listen to a thrilling southern sound of the modern era of the great country music.',
        spotify:'https://open.spotify.com/playlist/62JLOI18y2mnc25oijTmo9?si=eb565987fafb4729',
        
    },
    {
        imagesource: hiphop,
        title: "2023hiphop",
        text: 'Latest collection of trap and hiphop music with an energetic flow and master lyricism.',
        spotify:'https://open.spotify.com/playlist/7sfgPZqHTzj6pdj47Ir6Wn?si=521cba05b2984b6f',
        
    },
    {
        imagesource: oldie,
        title: "OldieVibe",
        text: '80s is said to be the golden age of music and this playlist is a collection of the greatest music.',
        spotify:'https://open.spotify.com/playlist/4DN9o1JhJRL5XU2K01Hyow?si=c93af9783e1947c4',
    },
    {
        imagesource: house,
        title: "EarlyHouse",
        text: 'House music on its early stages in the 90s was a whole vibe.Enjoy the new rythm of the dancing beats.',
        spotify:'https://open.spotify.com/playlist/6WyyODxvyNDXK8kIWGpN4W?si=098d62e297924e30',
        
        
    },
    {
        imagesource: sunflower,
        title: "Sunflower",
        text: 'Indie and modern music fan?? Sunflower is a pop playlist to make you bounce to the latest goodvibe hits.',
        Spotify:'https://open.spotify.com/playlist/7fPrwk8f3zx0eEbzloJxmL?si=761d03c3a58e4626',
        
        
    },
    {
        imagesource: rhumba,
        title: "Rhumba",
        text: 'African legendary collection of the best from the Congolese music, the playlist is full of energy and dancing spirit',
        spotify:'https://open.spotify.com/playlist/44QEE946HbAwzRUqCA7yJf?si=d9fd18b321de4b91',
        
        
    },
    {
        imagesource: latino,
        title: "Vibe-latina",
        text: 'Feeling spanish? the playlist here is all latino and good vibe playlist that is meant to be energetic and fun.',
        spotify:'https://open.spotify.com/playlist/4t04dJ9uNf56mekbyN1ypF?si=cbf216c22ad6403d',
        
        
    },
    {
        imagesource: edm,
        title: "EDM Summer",
        text: 'Best of the EDM era and some new one, this playlist is full of energy, adrenaline and madness mode meant to be fun.',
        spotify:'https://open.spotify.com/playlist/5UcF2Uy15sLwCjw36oJmgJ?si=5b048fb85d054cb7',
        
        
    },
    {
        imagesource: altrock,
        title: "Alt Rock",
        text: 'Not hard, not soft, just the right amount of rock music you need in your life with 68-hours of non-stop listening',
        spotify:'https://open.spotify.com/playlist/35uOACIvNkiQtg5N2LDC2r?si=a48f970a603643a4',
        
        
    },
    {
        imagesource: classicrock,
        title: "ClassicRock!",
        text: 'Full of adrenaline and energy, this playlist has the best of the world of rock from the 70s and 80s.',
        spotify:'https://open.spotify.com/playlist/35TiNmXNekY35Zt2BKXkyu?si=d525407c23dc42a5',
        
        
    },
    {
        imagesource: drill,
        title: "Drill and good vibes",
        text: 'Chaotic and vibrant, the drill genre from the UK is a new wave of sound thatis becoming popular acrros the world.',
        spotify:'https://open.spotify.com/playlist/27En6tZAenNU84dxjERRzZ?si=231a2f42c2114f30',
    },
    {
        imagesource: hadtobethere,
        title: "Had to be there",
        text: 'Pure nostalgia and fun of the yester years music, had to be there reflects of good memories of music from the 2010s.',
        spotify:'https://open.spotify.com/playlist/0g1vGR5t2EC5TOgP8ACwEb?si=9713b320c751466c',
    },
];

export default PlaylistData;